import React from 'react'
// import Header from '../Reusables/Header'
// import RBMTable from '../Tables/RBMTable'
import REPHQSelectionTable from '../Tables/REPHQSelectionTable'
const REPHQSelection = () => {
  return (
    <div className='home-screen' style={{padding:"20px"}}>
    <REPHQSelectionTable />
     {/* <RBMTable style={{marginTop:"20px",marginRight:"10px"}}/> */}
    </div>
  )
}

export default REPHQSelection
